import { gql } from '@apollo/client';
export const FETCH_ALL_SPECIAL_OFFERS = gql`
  query FetchAllSpecialOffer {
    fetchAllSpecialOffer {
        data {
            special_offers {
                updated_at
                start_date
                end_date
                status
                title
                description
                id
                created_at
                membership_duration_id
                number_of_days
                membership_duration {
                    created_at
                    price
                    number_of_days
                    description
                    package_id
                    updated_at
                    id
                    price_usd
                    duration_type
                    package {
                        package_order
                        name
                        description
                        created_at
                        package_type
                        information
                        updated_at
                        user_limit
                        id
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
}
`;